import { Injectable } from '@rxdi/core';
import { map } from 'rxjs/operators';

import { BaseGraphqlService } from '../base';

@Injectable()
export class NewsLetterService extends BaseGraphqlService {
  newsLetterSubscription(email) {
    return this.mutate({
      mutation: 'subscribe-newsletter.mutation.graphql',
      variables: {
        email,
      },
    }).pipe(map((res) => res.data.newsLetterSubscription));
  }
}
